// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-category[data-v-7cfaa758]{padding:1.25rem 0}@media screen and (pad){.card-category[data-v-7cfaa758]{padding:1.5rem 0}}.card-category .card-wrapper[data-v-7cfaa758]{align-items:flex-start;grid-gap:1.25rem;gap:1.25rem}.line-height-20[data-v-7cfaa758]{line-height:20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
